import { useGetRouteConst } from '@composables/useGetRouteConst'

/**
 * 라우트 간 이동 시 스크롤 위치를 저장하고 복원
 */
export const useScrollRestorationNested = () => {
  const route = useRoute()
  const { routeScrollPositions } = useLayoutStore()
  const { isApp } = useAppStore()
  const isModalPage = useGetRouteConst(String(route.name))?.isModalPage || false

  if (isModalPage) {
    onMounted(() => {
      if (route.matched.length > 1) {
        const parentRoute = route.matched[route.matched.length - 2]
        const parentRouteScrollPosition =
          routeScrollPositions[useGetRouteName(String(parentRoute.name))]
            ?.scrollPosition || 0
        const responsive = useGetResponsive()
        const isRequireScrollTop =
          isApp && parentRouteScrollPosition === 0 && responsive === 'mobile'

        if (document.body.scrollHeight <= window.innerHeight) {
          document.body.style.minHeight = '101vh'
        }

        setTimeout(() => {
          window.scrollTo({
            top: isRequireScrollTop ? 1 : parentRouteScrollPosition,
          })
        }, 100)
      }
    })

    onBeforeUnmount(() => {
      document.body.style.minHeight = ''
    })
  }
}
